import { useState, useEffect } from 'react';
import { gql, useQuery } from "@apollo/client";
import { CampaignByIdQueryDocument, CampaignByIdQuery } from "src/common/__generated__/api";
import CampaignRecommendations = CampaignByIdQuery.CampaignRecommendations;

const campaignByIdQuery = gql`
  ${CampaignByIdQueryDocument}
`;

export type CampaignByIdResponse = { campaignRecommendations: CampaignRecommendations };

const useCampaignByIdDynamic = (initialVariables) => {
  const [variables, setVariables] = useState(initialVariables);
  const [hotelSearchData, setHotelSearchData] = useState<CampaignByIdResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { data, refetch, loading } = useQuery<CampaignByIdResponse>(campaignByIdQuery, {
    variables,
    ssr: false,
    skip: !variables.campaignId
  }
  );

  useEffect(() => {
    setHotelSearchData(data);
  }, [data]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const updateVariables = (newVariables) => {
    setVariables(newVariables);
  };

  const fetchHotelData = () => {
    refetch();
  };

  return {
    hotelSearchData,
    variables,
    updateVariables,
    fetchHotelData,
    isLoading
  };
};

export default useCampaignByIdDynamic;
